import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFollowLink = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_466_4943)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M10.5 12.75C10.8221 13.1806 11.233 13.5369 11.7049 13.7947C12.1768 14.0525 12.6986 14.2058 13.235 14.2442C13.7713 14.2826 14.3097 14.2052 14.8135 14.0173C15.3173 13.8294 15.7748 13.5353 16.155 13.155L18.405 10.905C19.0881 10.1977 19.4661 9.25046 19.4575 8.26722C19.449 7.28398 19.0546 6.34343 18.3593 5.64815C17.664 4.95287 16.7235 4.55849 15.7403 4.54995C14.757 4.5414 13.8098 4.91938 13.1025 5.60247L11.8125 6.88497",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M13.5 11.25C13.1779 10.8195 12.767 10.4632 12.2951 10.2053C11.8232 9.94752 11.3014 9.79421 10.765 9.7558C10.2287 9.71738 9.69034 9.79477 9.18652 9.98271C8.6827 10.1706 8.22519 10.4647 7.84503 10.845L5.59503 13.095C4.91194 13.8023 4.53396 14.7496 4.5425 15.7328C4.55104 16.716 4.94543 17.6566 5.64071 18.3519C6.33599 19.0471 7.27654 19.4415 8.25977 19.4501C9.24301 19.4586 10.1903 19.0806 10.8975 18.3975L12.18 17.115",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_466_4943",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 18,
			height: 18,
			fill: "currentColor",
			transform: "translate(3 3)"
		})
	}) })]
});
export default SvgFollowLink;
